import { BaseError } from "./BaseError";
import type { ErrorContext } from "../types/index";
import { CONFLICT_ERROR_CODES } from "../constants/errorCodes";

export interface ConflictErrorOptions {
  message: string;
  resource?: string;
  conflictType?: string;
  context?: Partial<ErrorContext>;
  code?: string;
  cause?: Error;
}

/**
 * Error thrown when a conflict occurs (e.g., duplicate resource)
 */
export class ConflictError extends BaseError {
  public readonly resource?: string;
  public readonly conflictType?: string;

  constructor(options: ConflictErrorOptions) {
    super({
      message: options.message,
      category: "conflict",
      severity: "medium",
      statusCode: 409,
      code: options.code ?? CONFLICT_ERROR_CODES.CONFLICT_ERROR,
      context: options.context,
      cause: options.cause,
      userVisible: true,
      reportable: false,
    });

    this.resource = options.resource;
    this.conflictType = options.conflictType;
  }
}
